import "./bootstrap";
import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "../plugins/vuetify";
import router from "../router";
import i18n from '../plugins/i18n';
import { createPinia } from 'pinia';

import { loadAppConfig } from '../config/globalProperties';

const app = createApp(App);

// A configuracao precisa estar no window antes do router subir: o guard de
// rota depende de URL_APP_ADMIN para saber para onde mandar quem nao tem sessao.
loadAppConfig(app).then(async () => {
    app.use(router).use(vuetify).use(i18n).use(createPinia());

    // `router.isReady()` ANTES do mount, e nao depois.
    //
    // Sem isto o primeiro render acontece com a rota inicial ainda nao
    // resolvida: `route.meta` vem vazio, o App.vue conclui que o layout NAO e
    // `blank` e monta o cabecalho por cima da /sso. O AdminProfile le
    // `user.name` com `getUser()` nulo -- porque o handoff ainda nao gravou as
    // credenciais -- e a aplicacao inteira morre na tela de splash.
    //
    // So aparecia em navegador com storage limpo: com credenciais de uma
    // sessao anterior o `getUser()` respondia e nada quebrava. Ou seja, o
    // primeiro login de alguem, e todo login depois de um logout, que faz
    // `localStorage.clear()`.
    await router.isReady();

    app.mount("#app");
});
